<template lang="pug">
select.select-base(@change='changeSelect')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * セレクトタグ
 */
@Component
export default class SelectBase extends Vue {
  private changeSelect(event: Event): void {
    this.$emit('input', (event.target as HTMLSelectElement).value)
  }
}
</script>

<style lang="stylus" scoped>
.select-base
  cursor pointer
</style>
